import React from 'react';

import ComingSoon from '../ComingSoon';

const Reports: React.FC = () => {
  return <ComingSoon />;
};

export default Reports;
